import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import CertificationsPage from "@/pages/CertificationsPage";

export const Route = createFileRoute("/certifications")({
  head: () => pageHead("Certifications", "AKIVA maintains industry-leading certifications including SDVOSB, Virginia Values Veterans, and NYS SDVOB certification.", "/certifications", false),
  component: CertificationsPage,
});
